import { api, headers } from "./server";
import axios from "axios";

const API = axios.create({
  baseURL: api,
  headers,
});

const Serialize = (formData) => {
  var object = {};
  formData.forEach((value, key) => {
    object[key] = value;
  });
  return JSON.stringify(object);
};
window.SerializeFormData = Serialize;

export default API;
